import React, { useState } from "react";
import { FormBox } from "./FormBox";
import { TableBox } from "./TableBox";
import useNavModel, { RouterParamType } from "@/model/navModel";
import {PositionDrawer} from "./PositionDrawer";

export const BaseWarehouseDetails = () => {
    const { getSelectedNavState } = useNavModel(() => []);
    const [detailsInfo] = useState<RouterParamType>(getSelectedNavState() as RouterParamType);

    return (
        <>
            {detailsInfo && <>
                <FormBox {...detailsInfo}/>
                <TableBox {...detailsInfo}/>
                <PositionDrawer />
            </>
            }
        </>
    )
}